import { Link } from 'react-router-dom';
import Logo from '../base/Logo';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 bg-gradient-to-br from-emerald-500/20 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 bg-gradient-to-br from-blue-500/20 to-transparent rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 mb-8 sm:mb-10 lg:mb-12">
          {/* Company Info */}
          <div>
            <Logo inverted={true} className="mb-4 sm:mb-6 lg:mb-8" />
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-4 sm:mb-6 lg:mb-8">
              Expert en rénovation LED haute performance pour bâtiments tertiaires. Financement CEE BAT-EQ-127.
            </p>
            <div className="flex gap-2 sm:gap-3">
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-emerald-500 hover:to-teal-500 transition-all cursor-pointer group">
                <i className="ri-linkedin-fill text-base sm:text-lg lg:text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-emerald-500 hover:to-teal-500 transition-all cursor-pointer group">
                <i className="ri-facebook-fill text-base sm:text-lg lg:text-xl group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-emerald-500 hover:to-teal-500 transition-all cursor-pointer group">
                <i className="ri-twitter-fill text-base sm:text-lg lg:text-xl group-hover:scale-110 transition-transform"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 lg:mb-8 text-white">Navigation</h4>
            <ul className="space-y-2 sm:space-y-3 lg:space-y-4">
              <li>
                <Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/nos-produits" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Nos Produits
                </Link>
              </li>
              <li>
                <Link to="/nos-services" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Nos Services
                </Link>
              </li>
              <li>
                <Link to="/etude-gratuite" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Étude Gratuite
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 lg:mb-8 text-white">Contact</h4>
            <ul className="space-y-2 sm:space-y-3 lg:space-y-4">
              <li>
                <a href="mailto:contact@powereno.fr" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm flex items-center gap-2 sm:gap-3 cursor-pointer group">
                  <i className="ri-mail-line text-emerald-400 text-sm sm:text-base"></i>
                  <span className="break-all">contact@powereno.fr</span>
                </a>
              </li>
              <li className="text-gray-400 text-xs sm:text-sm flex items-center gap-2 sm:gap-3">
                <i className="ri-map-pin-line text-emerald-400 text-sm sm:text-base"></i>
                <span>Intervention nationale</span>
              </li>
              <li className="text-gray-400 text-xs sm:text-sm flex items-center gap-2 sm:gap-3">
                <i className="ri-time-line text-emerald-400 text-sm sm:text-base"></i>
                <span>Lun-Ven : 8h-18h</span>
              </li>
            </ul>
          </div>

          {/* Informations */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 lg:mb-8 text-white">Informations</h4>
            <ul className="space-y-2 sm:space-y-3 lg:space-y-4">
              <li>
                <Link to="/mentions-legales" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-de-confidentialite" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <a href="/politique-de-cookies" className="text-gray-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Politique de cookies
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-4 sm:pt-6 lg:pt-8 flex flex-col md:flex-row justify-center items-center gap-2 sm:gap-4">
          <p className="text-gray-400 text-xs sm:text-sm text-center">
            © 2025 Power Reno Pro. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
